import { InternalNetworkAssessmentEndGoalKindSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { InternalNetworkAttackPathEventKindSchema } from './internal-network-attack-path.schema';

export const INTERNAL_NETWORK_PROGRESS_SECRET_KEY_PATTERN =
  /pass(word)?|ntlm|hash|secret|token|cleartext|plaintext|private_?key/i;

export const InternalNetworkAssessmentProgressFootholdStatusSchema = z.enum([
  'OWNED',
  'IN_PROGRESS',
  'SUCCEEDED',
  'FAILED',
]);

export const InternalNetworkAssessmentProgressFootholdEventKindSchema = z.union(
  [InternalNetworkAttackPathEventKindSchema, z.literal('OWNED_SEED')],
);

export const InternalNetworkAssessmentProgressFootholdSchema = z.object({
  sourceId: z.string().min(1),
  status: InternalNetworkAssessmentProgressFootholdStatusSchema,
  eventKind: InternalNetworkAssessmentProgressFootholdEventKindSchema,
  host: z.string().nullable(),
  sourceHost: z.string().nullable(),
  principalId: z.string().nullable(),
  adEntityId: z.string().nullable(),
  weaknessId: z.string().nullable(),
  technique: z.string().nullable(),
  mitreTechniqueId: z.string().nullable(),
  lastEventId: z.string().nullable(),
  updatedAt: z.iso.datetime(),
});

export const InternalNetworkAssessmentProgressCredentialSchema = z
  .object({
    id: z.string().min(1),
    username: z.string().nullable(),
    domain: z.string().nullable(),
    label: z.string().nullable(),
  })
  .strict()
  .superRefine((value, ctx) => {
    for (const key of Object.keys(value)) {
      if (INTERNAL_NETWORK_PROGRESS_SECRET_KEY_PATTERN.test(key)) {
        ctx.addIssue({
          code: 'custom',
          message: `Credential field "${key}" may hold a secret and must not be stored on assessment progress`,
          path: [key],
        });
      }
    }
  });

export const InternalNetworkAssessmentProgressGoalSchema = z.object({
  key: z.string().min(1),
  kind: InternalNetworkAssessmentEndGoalKindSchema,
  crownJewelId: z.string().nullable(),
  label: z.string(),
  reached: z.boolean(),
});

export type InternalNetworkAssessmentProgressFootholdStatus = z.infer<
  typeof InternalNetworkAssessmentProgressFootholdStatusSchema
>;
export type InternalNetworkAssessmentProgressFootholdDto = z.infer<
  typeof InternalNetworkAssessmentProgressFootholdSchema
>;
export type InternalNetworkAssessmentProgressCredentialDto = z.infer<
  typeof InternalNetworkAssessmentProgressCredentialSchema
>;
export type InternalNetworkAssessmentProgressGoalDto = z.infer<
  typeof InternalNetworkAssessmentProgressGoalSchema
>;
